module.exports = __webpack_public_path__ + "087d04654c0c6c8de913ebbc322f2a17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/service_02.jpg
// module id = mIqt
// module chunks = 0